import { render, staticRenderFns } from "./AccountEdit.vue?vue&type=template&id=5fd364cd&scoped=true&"
import script from "./AccountEdit.vue?vue&type=script&lang=js&"
export * from "./AccountEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd364cd",
  null
  
)

export default component.exports